/** @jsx jsx */
import React from "react";
import PropTypes from "prop-types";
import { jsx, css } from "@emotion/core";
import { colors } from "../../theme";

const ProgressBar = ({ currentStage, numberOfStages }) => (
    <div
        css={css`
            position: relative;
            height: 10px;
        `}
    >
        <div
            css={css`
                height: 10px;
                width: ${(currentStage / numberOfStages) * 100}%;
                background-color: ${colors.primary7};
                border-radius: 5px;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
            `}
        />
        <div
            css={css`
                height: 10px;
                width: 100%;
                background-color: ${colors.neutral2};
                border-radius: 5px;
                position: absolute;
                top: 0;
                left: 0;
            `}
        />
    </div>
);

ProgressBar.propTypes = {
    currentStage: PropTypes.number.isRequired,
    numberOfStages: PropTypes.number.isRequired,
};

export default ProgressBar;
